// extracted by mini-css-extract-plugin
export default {"box":"product-details_box__XMv-L","title":"product-details_title__9PrkL"};